
import React from 'react';
import { Entry } from '../types';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from 'recharts'; // Added Cell
import { formatMilliseconds } from '../utils/formatters';

interface ResponseTimeChartProps {
  entries: Entry[];
}

const CustomTooltip: React.FC<any> = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div className="bg-white p-3 rounded shadow-lg border border-gray-300 text-sm">
        <p className="font-semibold text-violet-600 max-h-64 overflow-hidden max-w-xs">{data.url}</p>
        <p className="text-gray-800">Time: <span className="font-bold">{formatMilliseconds(data.time)}</span></p>
        <p className="text-gray-700">Status: <span className="font-bold">{data.status}</span></p>
      </div>
    );
  }
  return null;
};


const ResponseTimeChart: React.FC<ResponseTimeChartProps> = ({ entries }) => {
  if (!entries || entries.length === 0) {
    return <p className="text-gray-500 text-center py-4">No data to display chart.</p>;
  }

  const chartData = entries.map((entry, index) => ({
    index: index + 1,
    time: entry.time,
    url: entry.request.url,
    status: entry.response.status,
  }));

  const getBarColor = (entryTime: number, status: number) => {
    if (status >= 500) return '#ef4444'; // red-500
    if (status >= 400) return '#f97316'; // orange-500
    if (entryTime > 1000) return '#eab308'; // yellow-500
    if (entryTime > 500) return '#84cc16'; // lime-500
    return '#8b5cf6'; // violet-500 (Primary accent for default/good)
  };

  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer>
        <BarChart data={chartData} margin={{ top: 5, right: 0, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" /> {/* gray-200 */}
          <XAxis 
            dataKey="index" 
            tick={{ fontSize: 10, fill: '#6b7280' }}  /* gray-500 */
            label={{ value: 'Request Index', position: 'insideBottom', offset: -5, fill: '#6b7280', fontSize: 12 }}
          />
          <YAxis 
            tickFormatter={(value) => formatMilliseconds(value)} 
            tick={{ fontSize: 10, fill: '#6b7280' }} /* gray-500 */
            label={{ value: 'Time (ms)', angle: -90, position: 'insideLeft', fill: '#6b7280', fontSize: 12, dx: -10 }}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(124, 58, 237, 0.15)' }} /> {/* violet-600 with opacity */}
          <Bar dataKey="time">
            {
              chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={getBarColor(entry.time, entry.status)} />
              ))
            }
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ResponseTimeChart;